query payCycleSearchHints(
  $SearchRequestInput: SearchRequestInput!
  $isHistorySearch: Boolean
  $isLinkSearch: Boolean
  $isSigningSearch: Boolean
) {
  payCycleSearchHints(
    searchRequest: $SearchRequestInput
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
  ) {
    nodes {
      id
      linkType
      resultsCount
      caption
    }
  }
}
